export const dataHooks = {
    input: 'checkbox-input',
    label: 'checkbox-label',
    boxTooltip: 'checkbox-box-tooltip',
    box: 'checkbox-box',
    children: 'checkbox-children',
};
export const labelTextSizes = {
    small: 'small',
    medium: 'medium',
};
//# sourceMappingURL=constants.js.map